import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * React translation of the old {@code pages/quote/schaeffQuoteConfirmationPage.jsp}.
 *
 * The legacy JSP rendered the quote confirmation island first, followed by the
 * {@code FeedbackFormSlot}. The body replaces that island and the feedback slot
 * keeps the original wrapper classes.
 */
export function QuoteConfirmationPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <>
      {body}
      <div className="d-flex flex-direction-column flex-align-center">{slots.renderSlot("FeedbackFormSlot")}</div>
    </>
  );
}
